<template>
  <div class="c-snow-wrapper" v-show="desktop">
    <canvas class="c-snow" ref="canvas_snow"></canvas>
    <img ref="snow" class="u-hidden" src="/assets/sneeuwvlok.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Show',

  data () {
    return {
      desktop: false,
      canvas: '',
      ctx: '',
      particles: [],
      angle: 0,
      w: '',
      h: '',
      mp: 40,
      img: ''
    }
  },

  mounted () {
    this.desktop = (window.innerWidth > 1025)

    if (this.desktop) {
      // canvas dimensions
      this.canvas = this.$refs.canvas_snow
      this.ctx = this.canvas.getContext('2d')
      this.img = this.$refs.snow

      this.W = window.innerWidth
      this.H = window.innerHeight
      this.canvas.width = this.W
      this.canvas.height = this.H

      // snowflake particles
      for (var i = 0; i < this.mp; i++) {
        this.particles.push({
          x: Math.random() * this.W, // x-coordinate
          y: Math.random() * this.H, // y-coordinate
          r: Math.random() * 15 + 1, // radius
          size: Math.random() * 20 + 10, // size
          d: Math.random() * this.mp // density
        })
      }

      setInterval(this.draw, 33)
    }
  },

  methods: {
    draw () {
      this.ctx.clearRect(0, 0, this.W, this.H)
      for (var i = 0; i < this.mp; i++) {
        var p = this.particles[i]
        this.ctx.drawImage(this.img, p.x, p.y, p.size, p.size)
      }
      this.update()
    },

    update () {
      this.angle += 0.01
      for (var i = 0; i < this.mp; i++) {
        var p = this.particles[i]
        p.y += Math.cos(this.angle + p.d) + 1 + p.r / 2
        p.x += Math.sin(this.angle) * 2

        if (p.x > this.W + 5 || p.x < -5 || p.y > this.H) {
          if (i % 3 > 0) {
            this.particles[i] = { x: Math.random() * this.W, y: -10, r: p.r, d: p.d, size: p.size }
          } else {
            if (Math.sin(this.angle) > 0) {
              this.particles[i] = { x: -5, y: Math.random() * this.H, r: p.r, d: p.d, size: p.size }
            } else {
              this.particles[i] = { x: this.W + 5, y: Math.random() * this.H, r: p.r, d: p.d, size: p.size }
            }
          }
        }
      }
    }

  }

}
</script>
